// extracted by mini-css-extract-plugin
export default {"profile-image":"profile-image--tJj3u","profileImage":"profile-image--tJj3u"};